export default __webpack_public_path__ + "static/media/Teledermatologie_bg.59c96186.jpg";